import $ from 'jquery'

function appendLog($el, text) {
  if (!text) return
  $el.text($el.text() + text)
  $el.scrollTop($el[0].scrollHeight)
}

function setStatus($el, text) {
  $el.text(text)
}

async function startScrapeAndOpenModal(e) {
  e.preventDefault()

  const $btn = $(e.currentTarget)
  const startUrl = $btn.data('start-url')

  const $modal = $('#nasaaEfdScrapeModal')
  const $log = $('#nasaaEfdScrapeLog')
  const $status = $('#nasaaEfdScrapeStatus')

  $log.text('')
  setStatus($status, 'Starting file retrieval…')

  // Remove any existing review button from previous scrapes
  $modal.find('.modal-footer .btn-review-results').remove()

  $modal.modal('show')

  let runId
  try {
    const resp = await fetch(startUrl, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        'Accept': 'application/json'
      }
    })

    const data = await resp.json()

    if (!resp.ok) {
      throw new Error(data && data.error ? data.error : 'Failed to start scrape')
    }

    runId = data.run_id
    setStatus($status, `Filing retrieval running…`)
  } catch (err) {
    setStatus($status, `Error: ${err.message}`)
    return
  }

  // Poll progress endpoint
  let offset = 0
  let attempts = 0
  const maxAttempts = 60 * 30 // ~30 minutes if polling every 1s
  let fullLog = '' // Accumulate full log content

  while (attempts < maxAttempts) {
    attempts += 1

    try {
      const progressUrl = `/nasaa_efd_scraper_runs/${encodeURIComponent(runId)}/progress?offset=${offset}`
      const resp = await fetch(progressUrl, { headers: { 'Accept': 'application/json' } })

      if (resp.status === 404) {
        // Endpoint returns 404 if file isn't created yet; backoff a bit.
        await new Promise(r => setTimeout(r, 750))
        continue
      }

      const data = await resp.json()

      if (resp.ok) {
        appendLog($log, data.chunk)
        fullLog += data.chunk // Accumulate full log
        offset = data.offset

        if (data.done) {
          $log.scrollTop($log[0].scrollHeight)

          if (data.error || fullLog.includes('ERROR:')) {
            const errorMatch = fullLog.match(/ERROR: ([^\n]+)/)
            const errorText = errorMatch ? errorMatch[1] : 'See log below for details.'
            setStatus($status, `Filing retrieval failed: ${errorText}`)
            return
          }

          setStatus($status, 'Filing retrieval finished. Results are shown below.')

          // Extract cache_id from the full log (not just the last chunk)
          const cacheIdMatch = fullLog.match(/Cached scrape results \(ID: (\d+)\)/)

          if (cacheIdMatch && cacheIdMatch[1]) {
            const cacheId = cacheIdMatch[1]

            // Match hashid (alphanumeric) instead of just digits
            const issuerId = window.location.pathname.match(/\/admin\/issuers\/([a-zA-Z0-9]+)/)?.[1]

            if (issuerId) {
              const reviewUrl = `/admin/issuers/${issuerId}/nasaa_efd_scrape_caches/${cacheId}`

              // Append the button to the modal footer (before the Close button)
              const $footer = $modal.find('.modal-footer')
              const $reviewBtn = $('<a>', {
                href: reviewUrl,
                class: 'btn btn-primary btn-review-results',
                text: 'Review & Approve Results'
              })
              $footer.prepend($reviewBtn)
            }
          }

          return
        }
      } else {
        setStatus($status, 'Error reading progress.')
        return
      }
    } catch (err) {
      setStatus($status, `Error: ${err.message}`)
      return
    }

    await new Promise(r => setTimeout(r, 1000))
  }

  setStatus($status, 'Stopped polling (timeout).')
}

function initNasaaEfdScrapeModal() {
  $(document).on('click', '[data-action="start-nasaa-efd-scrape"]', startScrapeAndOpenModal)
}

// Initialize on full page load + turbolinks-like transitions (this app uses rails-ujs)
document.addEventListener('DOMContentLoaded', initNasaaEfdScrapeModal)
